import propTypes from 'prop-types';
import React from 'react';

import {QnectValidator} from "./qnect-validator";
import TextAreaField from "../../ui/components/form-fields/text-area-field";
import useConfig from "./qnect-config";
import {_getLang} from "../../store/system/service";
import {connect} from "react-redux";

const QnectTextAreaField = React.forwardRef((
    {
        lang,
        field,
        formId,
        label,
        value,
        rows,
        disabled,
        placeHolder,
        errorMessage,
        helperText,
        maxLength,
        onChange,
        onBlur,
        ...rest
    },
    ref
) => {

    const cfg = useConfig(lang);

        return (
            <QnectValidator
                formId={formId}
                lang={lang}
                onChangeCallback="onChange"
                errorMessage={errorMessage}
                validators={cfg(field, "validators")}
            >
                <TextAreaField
                    label={label || cfg(field, "label")}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    rows={rows}
                    helperText={helperText}
                    errorMessage={cfg(errorMessage)}
                    disabled={disabled}
                    maxLength={maxLength}
                >
                </TextAreaField>
            </QnectValidator>
        )
});

QnectTextAreaField.propTypes = {
    field: propTypes.string,
    formId: propTypes.string,
    label: propTypes.string,
    value: propTypes.string,
    rows: propTypes.number,
    disabled: propTypes.bool,
    className: propTypes.string,
    maxLength: propTypes.number,
    helperText: propTypes.string,
    errorMessage: propTypes.string,
    onChange: propTypes.func,
    onBlur: propTypes.func,
};

QnectTextAreaField.displayName = 'QnectTextAreaField';

const mapStateToProps = (state) => {
    return {
        lang: _getLang(state)
    }
};

export default connect(mapStateToProps)(QnectTextAreaField);
